import { useId } from 'react';

import { classlist } from '~/_shared/design-system/lib/classlist';
import { Label } from '~/_shared/design-system/ui/atoms/label/label';
import {
	TextInput,
	type TextInputProps,
} from '~/_shared/design-system/ui/atoms/text-input/text-input';

import './labeled-input.css';

interface LabeledInputProps extends Omit<TextInputProps, 'id'> {
	label: string;
	id?: string;
	wrapper_className?: string;
}

const LabeledInput = ({
	label,
	id,
	wrapper_className,
	className,
	...inputProps
}: LabeledInputProps) => {
	// Instance-unique default id: two label/input pairs on one page must not
	// collide (a duplicate id breaks the htmlFor association for one of
	// them). An explicit `id` prop still wins.
	const auto_id = useId();
	const resolved_id = id ?? `LabeledInput-${auto_id}`;
	return (
		<div className={classlist('labeled-input', wrapper_className)}>
			<Label htmlFor={resolved_id}>{label}</Label>
			<TextInput {...inputProps} id={resolved_id} className={className} />
		</div>
	);
};

export type { LabeledInputProps };
export { LabeledInput };
